(function () {
  'use strict';

  function injectHeaderBookCta() {
    var icons = document.querySelector('.header__icons--end');
    if (!icons || icons.querySelector('.fb-header-book')) return;
    var buttons = icons.querySelector('.header__buttons');
    if (!buttons) return;
    var a = document.createElement('a');
    a.href = '#fb-booking';
    a.className = 'fb-header-book fb-btn fb-btn--primary fb-btn--sm';
    a.textContent = 'Reserver dato';
    buttons.appendChild(a);
  }

  function initPromoBar() {
    document.querySelectorAll('[data-fb-promo-bar]').forEach(function (bar) {
      var messages = bar.querySelectorAll('.fb-promo-bar__message');
      var interval = 4200;
      var i = 0;

      if (messages.length > 1) {
        setInterval(function () {
          messages[i].classList.remove('is-active');
          i = (i + 1) % messages.length;
          messages[i].classList.add('is-active');
        }, interval);
      }

      var audienceKey = 'fb_audience';
      var current = 'privat';
      try {
        current = sessionStorage.getItem(audienceKey) || 'privat';
      } catch (e) {}

      bar.querySelectorAll('[data-fb-audience]').forEach(function (btn) {
        if (btn.dataset.fbAudience === current) btn.classList.add('is-active');
        else btn.classList.remove('is-active');

        btn.addEventListener('click', function () {
          current = btn.dataset.fbAudience;
          bar.querySelectorAll('[data-fb-audience]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          try { sessionStorage.setItem(audienceKey, current); } catch (e) {}
          document.body.dataset.fbAudience = current;
          document.dispatchEvent(new CustomEvent('fb:audience-change', { detail: { audience: current } }));
        });
      });

      document.body.dataset.fbAudience = current;
    });
  }

  function initCampaignRibbon() {
    document.querySelectorAll('[data-fb-campaign-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ribbon = btn.closest('.fb-campaign-ribbon');
        if (ribbon) {
          ribbon.hidden = true;
          try { sessionStorage.setItem('fb_campaign_ribbon', '0'); } catch (e) {}
        }
      });
    });
    try {
      if (sessionStorage.getItem('fb_campaign_ribbon') === '0') {
        document.querySelectorAll('.fb-campaign-ribbon').forEach(function (el) {
          el.hidden = true;
        });
      }
    } catch (e) {}
  }

  function initAiSliders() {
    document.querySelectorAll('[data-fb-ai-slider]').forEach(function (wrap) {
      var range = wrap.querySelector('.fb-ai__range');
      var before = wrap.querySelector('.fb-ai__before-wrap');
      var handle = wrap.querySelector('.fb-ai__handle');
      if (!range || !before) return;
      var update = function () {
        var v = range.value;
        before.style.width = v + '%';
        if (handle) handle.style.left = v + '%';
      };
      range.addEventListener('input', update);
      update();
    });
  }

  function hydrateCompare(compare) {
    if (compare.querySelector('[data-fb-compare-input]')) return;
    var imgs = Array.prototype.slice.call(compare.querySelectorAll('img')).filter(function (img) {
      return img.parentElement === compare || img.closest('[data-fb-compare]') === compare;
    });
    if (imgs.length < 2) return;
    var beforeImg = compare.querySelector('[data-fb-compare-before]') || imgs[0];
    var afterImg = compare.querySelector('[data-fb-compare-after]') || imgs[1];
    var beforeLabel = compare.getAttribute('data-before-label') || 'Før';
    var afterLabel = compare.getAttribute('data-after-label') || 'Etter';
    var sliderLabel = compare.getAttribute('data-slider-label') || (beforeLabel + ' / ' + afterLabel);
    var ratio = compare.getAttribute('data-ratio');
    if (ratio) compare.style.setProperty('--fb-compare-ratio', ratio.replace('/', ' / '));

    compare.innerHTML = '';
    function layer(img, cls, label, extraAttr) {
      var wrap = document.createElement('div');
      wrap.className = cls;
      if (extraAttr) wrap.setAttribute(extraAttr, '');
      if (cls.indexOf('before') !== -1) wrap.style.clipPath = 'inset(0 50% 0 0)';
      img.removeAttribute('width');
      img.removeAttribute('height');
      wrap.appendChild(img);
      var tag = document.createElement('span');
      tag.className = 'fb-compare__label ' + (cls.indexOf('before') !== -1 ? 'fb-compare__label--before' : 'fb-compare__label--after');
      tag.textContent = label;
      wrap.appendChild(tag);
      return wrap;
    }
    compare.appendChild(layer(afterImg, 'fb-compare__after', afterLabel));
    compare.appendChild(layer(beforeImg, 'fb-compare__before', beforeLabel, 'data-fb-compare-before'));
    var handle = document.createElement('div');
    handle.className = 'fb-compare__handle';
    handle.setAttribute('data-fb-compare-handle', '');
    handle.setAttribute('aria-hidden', 'true');
    handle.style.left = '50%';
    compare.appendChild(handle);
    var input = document.createElement('input');
    input.type = 'range';
    input.className = 'fb-compare__input';
    input.min = '0';
    input.max = '100';
    input.value = '50';
    input.setAttribute('aria-label', sliderLabel);
    input.setAttribute('data-fb-compare-input', '');
    compare.appendChild(input);
  }

  function bindCompare(compare) {
    if (compare.dataset.fbCompareReady) return;
    var input = compare.querySelector('[data-fb-compare-input]');
    var before = compare.querySelector('[data-fb-compare-before]');
    var handle = compare.querySelector('[data-fb-compare-handle]');
    if (!input || !before) return;
    var update = function (value) {
      before.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
      if (handle) handle.style.left = value + '%';
    };
    var ratio = compare.getAttribute('data-ratio');
    if (ratio) compare.style.setProperty('--fb-compare-ratio', ratio.replace('/', ' / '));
    input.addEventListener('input', function () { update(input.value); });
    update(input.value);
    compare.dataset.fbCompareReady = '1';
    if (compare.hasAttribute('data-fb-compare-nudge')) {
      setupCompareNudge(compare, input, update);
    }
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function setupCompareNudge(compare, input, update) {
    if (compare.dataset.fbCompareNudgeReady) return;
    compare.dataset.fbCompareNudgeReady = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cancelled = false;
    var cancel = function () {
      cancelled = true;
    };
    input.addEventListener('pointerdown', cancel, { passive: true });
    input.addEventListener('touchstart', cancel, { passive: true });
    input.addEventListener('keydown', cancel);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          if (compare.dataset.fbCompareNudged) return;
          compare.dataset.fbCompareNudged = '1';
          observer.disconnect();
          runCompareNudge(input, update, function () {
            return cancelled;
          });
        });
      },
      { threshold: [0.5, 0.65] }
    );
    observer.observe(compare);
  }

  function runCompareNudge(input, update, isCancelled) {
    var duration = 1800;
    var start = null;

    function sample(p) {
      // 50 → 72 → 28 → 50 with ease-in-out segments
      if (p < 0.34) {
        var t = easeInOutCubic(p / 0.34);
        return 50 + (72 - 50) * t;
      }
      if (p < 0.72) {
        var t2 = easeInOutCubic((p - 0.34) / 0.38);
        return 72 + (28 - 72) * t2;
      }
      var t3 = easeInOutCubic((p - 0.72) / 0.28);
      return 28 + (50 - 28) * t3;
    }

    function frame(now) {
      if (isCancelled()) return;
      if (start == null) start = now;
      var p = Math.min(1, (now - start) / duration);
      var value = Math.round(sample(p));
      input.value = String(value);
      update(value);
      if (p < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function initCompareSliders() {
    document.querySelectorAll('[data-fb-compare]').forEach(function (compare) {
      hydrateCompare(compare);
      bindCompare(compare);
    });
  }

  function slugHeading(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[^\wæøåäöü]+/gi, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 48);
  }

  function isSynopsisHeading(text) {
    var t = String(text || '').trim().toLowerCase();
    return t === 'på 20 sekunder' || t === 'pa 20 sekunder' || t === 'in 20 seconds' || t === 'kort fortalt' || t === 'synopsis';
  }

  function initArticleSynopsis() {
    var body = document.querySelector('[data-fb-article-body]');
    var box = document.querySelector('[data-fb-synopsis]');
    var mount = document.querySelector('[data-fb-synopsis-body]');
    if (!body || !box || !mount) return;

    var heading = body.querySelector('h2');
    if (!heading || !isSynopsisHeading(heading.textContent)) return;

    mount.innerHTML = '';
    var node = heading.nextElementSibling;
    heading.remove();
    while (node && node.tagName !== 'H2') {
      var next = node.nextElementSibling;
      mount.appendChild(node);
      node = next;
    }
    if (!mount.textContent.trim()) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
  }

  function initArticleToc() {
    document.querySelectorAll('[data-fb-toc]').forEach(function (nav) {
      var body = document.querySelector('[data-fb-article-body]');
      var list = nav.querySelector('[data-fb-toc-list]');
      if (!body || !list) return;
      var headings = body.querySelectorAll('h2');
      if (!headings.length) return;
      headings.forEach(function (h, i) {
        var text = (h.textContent || '').trim();
        if (!text || isSynopsisHeading(text)) return;
        var slug = slugHeading(text);
        if (!h.id) {
          h.id = /^fotobaren/.test(slug) ? 'fotobaren' : 'fb-h-' + (i + 1) + '-' + slug;
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = text;
        li.appendChild(a);
        list.appendChild(li);
      });
      if (!list.children.length) return;
      nav.hidden = false;
    });
  }

  function initArticleBodyCleanup() {
    var body = document.querySelector('[data-fb-article-body]');
    if (!body) return;
    body.querySelectorAll('h2').forEach(function (h) {
      if (!(h.textContent || '').trim()) h.remove();
    });
  }

  function initArticleStickyOffset() {
    var shell = document.querySelector('.fb-header-shell');
    if (!shell) return;
    var apply = function () {
      var h = Math.ceil(shell.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--fb-sticky-offset', h + 'px');
    };
    apply();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(apply).observe(shell);
    } else {
      window.addEventListener('resize', apply);
    }
  }

  function initOccasionAudience() {
    function getAudience() {
      return document.body.dataset.fbAudience || 'privat';
    }

    function optionVisible(btn, audience) {
      var scope = btn.dataset.fbOccasionAudience || 'all';
      return scope === 'all' || scope === audience;
    }

    function applyMegaAudience(audience) {
      document.querySelectorAll('[data-fb-mega-audience]').forEach(function (group) {
        var scope = group.dataset.fbMegaAudience || 'all';
        var show = scope === 'all' || scope === audience;
        group.hidden = !show;
        group.style.display = show ? '' : 'none';
      });

      document.querySelectorAll('[data-fb-mega-panel-mount] .fb-mega-menu__groups').forEach(function (wrap) {
        var visible = wrap.querySelectorAll('.fb-mega-menu__group:not([hidden])');
        wrap.classList.toggle('fb-mega-menu__groups--single', visible.length === 1);
        visible.forEach(function (group) {
          var eyebrow = group.querySelector('.fb-mega-menu__eyebrow');
          if (!eyebrow) return;
          eyebrow.textContent = audience === 'bedrift' ? 'Bedriftsanledninger' : 'Private anledninger';
        });
      });
    }

    function applyOccasionTiles(audience) {
      document.querySelectorAll('.fb-occasions__tile[data-fb-occasion-audience]').forEach(function (tile) {
        var scope = tile.dataset.fbOccasionAudience || 'all';
        var show = scope === 'all' || scope === audience;
        tile.hidden = !show;
        tile.style.display = show ? '' : 'none';
      });
      document.querySelectorAll('[data-fb-occasions-note]').forEach(function (note) {
        note.hidden = false;
        note.textContent = audience === 'bedrift'
          ? 'Viser bedriftsanledninger — bytt til Privat øverst hvis du booker privat fest.'
          : 'Viser private anledninger — bytt til Bedrift øverst for firma, julebord og kickoff.';
      });
    }

    function applyAudience(audience) {
      document.body.dataset.fbAudience = audience;
      applyMegaAudience(audience);
      applyOccasionTiles(audience);

      document.querySelectorAll('[data-fb-occasion-bar]').forEach(function (bar) {
        var current = bar.querySelector('[data-fb-occasion-current]');
        var reset = bar.querySelector('[data-fb-occasion-reset]');
        var placeholder = bar.dataset.fbOccasionPlaceholder;
        var visibleCount = 0;
        var selectedVisible = false;

        bar.querySelectorAll('[data-fb-occasion-value]').forEach(function (btn) {
          var show = optionVisible(btn, audience);
          btn.hidden = !show;
          btn.style.display = show ? '' : 'none';
          if (show) visibleCount += 1;
          if (show && current && current.textContent === (btn.dataset.fbOccasionLabel || btn.textContent.trim())) {
            selectedVisible = true;
          }
        });

        if (current && !selectedVisible && placeholder) {
          current.textContent = placeholder;
          if (reset) reset.hidden = true;
          try { sessionStorage.removeItem('fb_occasion'); } catch (err) {}
          var cleared = { value: null, label: null, source: 'audience' };
          bar.dispatchEvent(new CustomEvent('fb:occasion-change', { bubbles: true, detail: cleared }));
          document.dispatchEvent(new CustomEvent('fb:occasion-change', { detail: cleared }));
        }

        if (visibleCount === 0 && current && placeholder) {
          current.textContent = placeholder;
        }
      });
    }

    document.querySelectorAll('[data-fb-occasion-bar]').forEach(function (bar) {
      var toggle = bar.querySelector('[data-fb-occasion-toggle]');
      if (toggle && !bar.dataset.fbOccasionPlaceholder) {
        var current = bar.querySelector('[data-fb-occasion-current]');
        bar.dataset.fbOccasionPlaceholder = current ? current.textContent.trim() : '';
      }
    });

    applyAudience(getAudience());

    document.addEventListener('fb:audience-change', function (e) {
      applyAudience((e.detail && e.detail.audience) || getAudience());
    });
    document.addEventListener('fb:mega-shown', function () {
      applyAudience(getAudience());
    });
  }

  function initHeaderShell() {
    var shell = document.querySelector('[data-fb-header-shell]');
    var mount = document.querySelector('[data-fb-occasion-mount]');
    var occasionBar = document.querySelector('[data-fb-occasion-bar]');
    if (!shell || !mount || !occasionBar || mount.contains(occasionBar)) return;

    var occasionSection = occasionBar.closest('.shopify-section');
    mount.appendChild(occasionBar);

    if (occasionSection && !occasionSection.classList.contains('header-section')) {
      occasionSection.hidden = true;
    }

    shell.addEventListener('mouseleave', function (e) {
      if (shell.contains(e.relatedTarget)) return;
      hideFbMegaPanels();
      document.querySelectorAll('.header__menu details[open]').forEach(function (el) {
        el.open = false;
      });
    });
  }

  function hideFbMegaPanels() {
    var panelsWrap = document.querySelector('[data-fb-mega-panels]');
    if (!panelsWrap) return;
    var mount = panelsWrap.querySelector('[data-fb-mega-panel-mount]');
    if (mount) mount.innerHTML = '';
    panelsWrap.classList.add('is-closed');
    panelsWrap.classList.remove('is-open');
    panelsWrap.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('with-mega');
    document.body.classList.remove('fb-mega-open');
  }

  function showFbMegaPanel(id) {
    var panelsWrap = document.querySelector('[data-fb-mega-panels]');
    if (!panelsWrap) return;
    var template = panelsWrap.querySelector('[data-fb-mega-template="' + id + '"]');
    var mount = panelsWrap.querySelector('[data-fb-mega-panel-mount]');
    if (!template || !mount) return;

    mount.innerHTML = '';
    mount.appendChild(template.content.cloneNode(true));
    panelsWrap.classList.remove('is-closed');
    panelsWrap.classList.add('is-open');
    panelsWrap.setAttribute('aria-hidden', 'false');
    document.body.classList.add('with-mega');
    document.body.classList.add('fb-mega-open');
    document.dispatchEvent(new CustomEvent('fb:mega-shown'));
  }

  function initFbMegaPanels() {
    var panelsWrap = document.querySelector('[data-fb-mega-panels]');
    if (!panelsWrap) return;

    hideFbMegaPanels();

    panelsWrap.addEventListener('mouseenter', function () {
      if (!panelsWrap.classList.contains('is-open')) return;
    });

    panelsWrap.addEventListener('mouseleave', function (e) {
      var shell = document.querySelector('[data-fb-header-shell]');
      if (shell && shell.contains(e.relatedTarget)) return;
      hideFbMegaPanels();
    });

    document.querySelectorAll('.header__menu details[data-fb-mega-trigger]').forEach(function (details) {
      var id = details.getAttribute('data-fb-mega-trigger');
      if (!id) return;

      details.addEventListener('mouseenter', function () {
        showFbMegaPanel(id);
      });

      details.addEventListener('toggle', function () {
        if (details.open) showFbMegaPanel(id);
      });
    });
  }

  function initFastNavMenus() {
    var dropdown = customElements.get('details-dropdown');
    var mega = customElements.get('details-mega');
    if (!dropdown || !window.theme) return;

    var noopIn = async function () {
      this.contentElement.style.opacity = '0';
      this.contentElement.style.visibility = 'hidden';
      return Promise.resolve();
    };

    var noopOut = async function () {
      return Promise.resolve();
    };

    dropdown.prototype.transitionIn = async function () {
      if (this.contentElement.classList.contains('fb-dropdown-menu') || this.contentElement.classList.contains('fb-mega-menu--stub')) {
        return noopIn.call(this);
      }
      if (!window.Motion) return Promise.resolve();
      var ease = [0.7, 0, 0.2, 1];
      var reduced = theme.config.motionReduced;
      Motion.animate(this.contentElement, { opacity: [0, 1], visibility: 'visible' }, { duration: reduced ? 0 : 0.15, easing: ease });
      var translateY = this.level === 'top' ? '-105%' : '2rem';
      return Motion.animate(this.contentElement.firstElementChild, { transform: ['translateY(' + translateY + ')', 'translateY(0)'] }, { duration: reduced ? 0 : 0.15, easing: ease }).finished;
    };

    dropdown.prototype.transitionOut = async function () {
      if (this.contentElement.classList.contains('fb-dropdown-menu') || this.contentElement.classList.contains('fb-mega-menu--stub')) {
        return noopOut.call(this);
      }
      if (!window.Motion) return Promise.resolve();
      var ease = [0.7, 0, 0.2, 1];
      var reduced = theme.config.motionReduced;
      Motion.animate(this.contentElement, { opacity: 0, visibility: 'hidden' }, { duration: reduced ? 0 : 0.1, easing: ease });
      var translateY = this.level === 'top' ? '-105%' : '2rem';
      return Motion.animate(this.contentElement.firstElementChild, { transform: 'translateY(' + translateY + ')' }, { duration: reduced ? 0 : 0.1, easing: ease }).finished;
    };

    if (mega) {
      mega.prototype.transitionIn = noopIn;
      mega.prototype.transitionOut = noopOut;
    }
  }

  function initIzyRentLocalization() {
    if (!document.querySelector('form[action*="/cart/add"]')) return;

    var SUBSTRINGS = [
      ['Return :', 'Retur:'],
      ['Return:', 'Retur:'],
      ['Please select a date', 'Vennligst velg en dato']
    ];
    var EXACT = {
      'Clear': 'Nullstill',
      'Save': 'Lagre'
    };

    function translateTextNodes(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var text = node.textContent;
        var trimmed = text.trim();
        if (!trimmed) continue;
        if (EXACT[trimmed]) {
          node.textContent = text.replace(trimmed, EXACT[trimmed]);
          continue;
        }
        SUBSTRINGS.forEach(function (pair) {
          if (text.indexOf(pair[0]) !== -1) {
            node.textContent = text.split(pair[0]).join(pair[1]);
            text = node.textContent;
          }
        });
      }
    }

    function apply() {
      var wrap = document.getElementById('izyrent');
      if (wrap) {
        wrap.querySelectorAll('input.izyDate').forEach(function (el) {
          if (el.placeholder === 'Book your day') el.placeholder = 'Velg dato';
        });
        translateTextNodes(wrap);
        // The rental price lives on the product itself, so a "0,00 kr" fee
        // line in the recap is just noise — hide it.
        wrap.querySelectorAll('#izyRecap .recap span').forEach(function (s) {
          if (/^0([.,]00?)?\s*kr$/i.test(s.textContent.trim())) s.style.display = 'none';
        });
      }
      document.querySelectorAll('.flatpickr-calendar .izyclear, .flatpickr-calendar .izysave').forEach(function (btn) {
        translateTextNodes(btn);
      });
    }

    // IzyRent injects and re-renders its widget asynchronously, so keep a
    // lightweight polling translator alive on product pages.
    apply();
    setInterval(apply, 600);
  }

  function titleCasePlace(s) {
    return String(s || '').toLowerCase().replace(/(^|[\s\-/])\S/g, function (c) {
      return c.toUpperCase();
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* Kartverket / Geonorge — official Norwegian street addresses.
     Same idea as Google Places, without an API key and better for NO. */
  function bindAddressAutocomplete(input, opts) {
    if (!input || input.dataset.fbAddrBound === '1') return;
    opts = opts || {};
    input.dataset.fbAddrBound = '1';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    var wrap = input.closest('.fb-addr');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'fb-addr';
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(input);
    }
    var list = wrap.querySelector('.fb-addr__list');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'fb-addr__list';
      list.hidden = true;
      list.setAttribute('role', 'listbox');
      wrap.appendChild(list);
    }
    var listId = input.id ? input.id + '-list' : 'fb-addr-list';
    list.id = listId;
    input.setAttribute('aria-controls', listId);

    var seq = 0;
    var timer = null;
    var hits = [];
    var active = -1;

    function hide() {
      list.hidden = true;
      list.innerHTML = '';
      hits = [];
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function highlight() {
      list.querySelectorAll('[data-fb-addr-i]').forEach(function (el, i) {
        var on = i === active;
        el.classList.toggle('is-active', on);
        if (on) el.setAttribute('aria-selected', 'true');
        else el.removeAttribute('aria-selected');
      });
    }

    function pick(i) {
      var hit = hits[i];
      if (!hit) return;
      hide();
      if (typeof opts.onSelect === 'function') opts.onSelect(hit);
    }

    function renderHits(rows) {
      hits = rows || [];
      active = hits.length ? 0 : -1;
      if (!hits.length) {
        list.innerHTML = '<li class="fb-addr__empty">Ingen treff — sjekk gatenavn og nummer.</li>';
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }
      list.innerHTML = hits.map(function (h, i) {
        return '<li role="option" data-fb-addr-i="' + i + '"' +
          (i === 0 ? ' class="is-active" aria-selected="true"' : '') + '>' +
          '<span class="fb-addr__street">' + escapeHtml(h.street) + '</span>' +
          '<span class="fb-addr__meta">' + escapeHtml((h.postnr + ' ' + h.poststed).trim()) + '</span></li>';
      }).join('');
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function mapHits(data) {
      return ((data && data.adresser) || []).map(function (a) {
        return {
          street: a.adressetekst || [a.adressenavn, a.nummer, a.bokstav].filter(Boolean).join(' '),
          postnr: a.postnummer || '',
          poststed: titleCasePlace(a.poststed || ''),
        };
      }).filter(function (h) { return h.street; });
    }

    function search() {
      var q = (input.value || '').trim();
      if (q.length < 3) { hide(); return; }
      var my = ++seq;
      var sok = /\*$/.test(q) ? q : q + '*';
      var postnr = typeof opts.getPostnr === 'function' ? String(opts.getPostnr() || '').replace(/\D/g, '') : '';

      function run(usePost) {
        var url = 'https://ws.geonorge.no/adresser/v1/sok?sok=' + encodeURIComponent(sok) + '&treffPerSide=8';
        if (usePost && /^\d{4}$/.test(postnr)) url += '&postnummer=' + postnr;
        return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          if (my !== seq) return;
          var rows = mapHits(data);
          if (!rows.length && usePost && /^\d{4}$/.test(postnr)) return run(false);
          renderHits(rows);
        });
      }

      run(/^\d{4}$/.test(postnr)).catch(function () {
        if (my !== seq) return;
        hide();
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(search, 220);
    });
    input.addEventListener('focus', function () {
      if ((input.value || '').trim().length >= 3 && list.hidden) search();
    });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        active = Math.min(hits.length - 1, active + 1);
        highlight();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        active = Math.max(0, active - 1);
        highlight();
      } else if (e.key === 'Enter' && active >= 0) {
        e.preventDefault();
        pick(active);
      } else if (e.key === 'Escape') {
        hide();
      }
    });
    list.addEventListener('mousedown', function (e) {
      var li = e.target.closest('[data-fb-addr-i]');
      if (!li) return;
      e.preventDefault();
      pick(+li.getAttribute('data-fb-addr-i'));
    });
    wrap.addEventListener('focusout', function (e) {
      if (!wrap.contains(e.relatedTarget)) hide();
    });
  }

  window.FotobarenAddressLookup = { bind: bindAddressAutocomplete };

  function initMinBookingHandoff() {
    var path = window.location.pathname || '';
    if (/min-booking/i.test(path)) return;
    var data = null;
    try {
      data = JSON.parse(localStorage.getItem('fb_min_booking_handoff') || 'null');
    } catch (e) {
      return;
    }
    if (!data || !data.ts || Date.now() - data.ts > 7 * 24 * 60 * 60 * 1000) return;
    try {
      if (sessionStorage.getItem('fb_min_booking_handoff_hide') === '1') return;
    } catch (e2) {}

    var main = document.getElementById('MainContent');
    if (!main || main.querySelector('.fb-handoff')) return;

    var url = data.url || '/pages/min-booking';
    if (data.email) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + 'email=' + encodeURIComponent(data.email);
    }

    var bar = document.createElement('div');
    bar.className = 'fb-handoff';
    bar.innerHTML =
      '<div class="fb-handoff__inner">' +
        '<p class="fb-handoff__text">Har du nettopp reservert? Se, fullfør og endre bookingen på Min reservasjon.</p>' +
        '<div class="fb-handoff__actions">' +
          '<a class="fb-btn fb-btn--primary fb-handoff__cta" href="' + escapeHtml(url) + '">Se og fullfør min reservasjon</a>' +
          '<button type="button" class="fb-handoff__close" aria-label="Lukk">×</button>' +
        '</div>' +
      '</div>';
    bar.querySelector('.fb-handoff__close').addEventListener('click', function () {
      bar.remove();
      try { sessionStorage.setItem('fb_min_booking_handoff_hide', '1'); } catch (e3) {}
    });
    main.insertBefore(bar, main.firstChild);
  }

  function initHashScroll() {
    function scrollToHash(hash, behavior) {
      if (!hash || hash === '#') return false;
      var id = decodeURIComponent(hash.replace(/^#/, ''));
      if (!id) return false;
      var el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
      return true;
    }

    if (location.hash) {
      window.setTimeout(function () {
        scrollToHash(location.hash, 'smooth');
      }, 80);
    }

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hashIdx = href.indexOf('#');
      if (hashIdx < 0) return;
      var path = href.slice(0, hashIdx);
      var hash = href.slice(hashIdx);
      var samePage =
        !path ||
        path === '/' ||
        path === location.pathname ||
        path === location.pathname + location.search;
      if (!samePage) return;
      if (!scrollToHash(hash, 'smooth')) return;
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', hash);
    });
  }

  function init() {
    initHeaderShell();
    initFastNavMenus();
    initFbMegaPanels();
    injectHeaderBookCta();
    initPromoBar();
    initOccasionAudience();
    initCampaignRibbon();
    initMinBookingHandoff();
    initArticleSynopsis();
    initArticleBodyCleanup();
    initAiSliders();
    initCompareSliders();
    initArticleToc();
    initArticleStickyOffset();
    initIzyRentLocalization();
    initHashScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
